export default __webpack_public_path__ + "static/media/4.a75a0c01.png";